<template>
  <div ref="container">
    <div class="coupon-search">
      <input
        class="coupon-search-input"
        placeholder="请输入兑换码"
        type="text"
        v-model.trim="inputValue"
        @input="searchInput"
      />
      <button
        class="coupon-search-btn"
        :class="searchBtnDisabled == true ? 'disabled' : ''"
        @click="serachCouponConfirm"
      >
        兑换
      </button>
    </div>
    <div class="coupon-list" v-if="couponsList">
      <div class="item acea-row row-center-wrapper">
        <div class="money" :class="couponsList.is_use ? 'moneyGray' : ''">
          <div>
            ￥<span class="num">{{ couponsList.coupon_price }}</span>
          </div>
          <div class="pic-num">满{{ couponsList.use_min_price }}元可用</div>
        </div>
        <div class="text">
          <div class="condition line1">
            <span
              class="line-title"
              :class="
                couponsList.is_use === true || couponsList.is_use === 2
                  ? 'bg-color-huic'
                  : 'bg-color-check'
              "
              v-if="couponsList.type === 0"
              >通用劵</span
            >
            <span
              class="line-title"
              :class="
                couponsList.is_use === true || couponsList.is_use === 2
                  ? 'bg-color-huic'
                  : 'bg-color-check'
              "
              v-else-if="couponsList.type === 1"
              >品类券</span
            >
            <span
              class="line-title"
              :class="
                couponsList.is_use === true || couponsList.is_use === 2
                  ? 'bg-color-huic'
                  : 'bg-color-check'
              "
              v-else
              >商品券</span
            >
            <span>{{ couponsList.title }}</span>
          </div>
          <div class="data acea-row row-between-wrapper">
            <div v-if="couponsList.end_time !== 0">
              {{ couponsList.start_time ? couponsList.start_time + "-" : ""
              }}{{ couponsList.end_time }}
            </div>
            <div v-else>不限时</div>
            <div class="bnt gray" v-if="couponsList.is_use === true">
              已领取
            </div>
            <div class="bnt gray" v-else-if="couponsList.is_use === 2">
              已领完
            </div>
            <div
              class="bnt bg-color-red"
              v-else
              @click="getCoupon(couponsList.code)"
            >
              立即领取
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loading="loading"></Loading>
    <!--暂无优惠券-->
    <div class="noCommodity" v-cloak v-if="!couponsList">
      <div class="noPictrue">
        <img src="@assets/images/noCoupon.png" class="image" />
      </div>
    </div>
  </div>
</template>
<script>
import { exchangeCoupon, issueCoupon } from "@api/user";
import Loading from "@components/Loading";
export default {
  name: "getCodeCoupon",
  components: {
    Loading,
  },
  props: {},
  data: function () {
    return {
      couponsList: "",
      loading: false,
      inputValue: "",
      searchBtnDisabled: true,
    };
  },
  mounted: function () {
    // this.getUseCoupons();
    // this.$scroll(this.$refs.container, () => {
    //   !this.loading && this.getUseCoupons();
    // });
  },
  methods: {
    getCoupon: function (code) {
      let that = this;
      let list = that.couponsList;
      exchangeCoupon(code)
        .then(function () {
          list.is_use = true;
          that.$dialog.toast({ mes: "领取成功" });
          setTimeout(function () {
            that.$router.push({ path: "/activity/goods_seckill" });
          }, 500);
        })
        .catch(function (res) {
          that.$dialog.toast({ mes: res.msg });
        });
    },
    searchInput: function () {
      var value = this.inputValue;
      if (value && value !== "") {
        this.searchBtnDisabled = false;
      } else {
        this.searchBtnDisabled = true;
        this.couponsList = "";
      }
    },
    serachCouponConfirm: function () {
      let that = this;
      var code = that.inputValue;
      if (code != "") {
        if (that.loading) return; //阻止下次请求（false可以进行请求）；
        that.loading = true;
        issueCoupon(code)
          .then((res) => {
            that.loading = false;
            //apply();js将一个数组插入另一个数组;
            that.couponsList = res.data;
          })
          .catch((err) => {
            that.$dialog.toast({ mes: err.msg });
            that.loading = false;
            that.couponsList = "";
          });
      }
    },
  },
};
</script>
